import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-transaction-page',
  templateUrl: './transaction-page.component.html',
  styleUrls: ['./transaction-page.component.scss'],
})
export class TransactionPageComponent implements OnInit, OnDestroy {
  success = false;
  fail = false;
  timeoutIds: any = []; // Declare timeoutFunction here
  waitingValidation = true;

  constructor(
    private transactionService: TansactionService,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {
    if (this.localStorageService.getItem('reloadPage') == 'true') {
      this.localStorageService.removeItem('reloadPage');
      window.location.reload();
    }
  }

  ngOnDestroy(): void {
    this.timeoutIds.forEach(timeoutId => {
      clearTimeout(timeoutId);
    });

  }

  ngOnInit(): void {
    this.route.params.subscribe((data) => {
      this.getOrderDetails(data.id);
    });
  }

  getOrderDetails(orderId) {
    this.transactionService
      .verifyCart({
        orderId: orderId,
      })
      .then((data: any) => {
        data = data.data;
        if (
          data.event == 'order.paid' ||
          data.event == 'payment.authorized' ||
          data.event == 'payment.captured'
        ) {
          this.waitingValidation = false;
          this.success = true;
        } else if (
          data.event == 'payment.failed' ||
          data.event == 'subscription.cancelled' ||
          data.event == 'fund_account.validation.failed'
        ) {
          this.waitingValidation = false;
          this.fail = true;
        } else {
          this.timeoutIds.push(setTimeout(() => {
            this.getOrderDetails(orderId);
          }, 1000));
        }
      })
      .catch((err) => {
        this.waitingValidation = false;
        console.log(err);
      });
  }
}
